/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ToolHistoryEntry = {
    changes: Record<string, any>;
    event_group: ToolHistoryEntry.event_group;
    type: ToolHistoryEntry.type;
    readonly creator_id: string;
    readonly created_at: string;
};
export namespace ToolHistoryEntry {
    export enum event_group {
        TOOL = 'tool',
        RESPONSIBILITY = 'responsibility',
        DOCUMENTS = 'documents',
        INVENTORY = 'inventory',
    }
    export enum type {
        CREATE = 'create',
        UPDATE = 'update',
        ASSIGN = 'assign',
        REJECT = 'reject',
        TAKE = 'take',
        RETURN = 'return',
        MAKE_AVAILABLE = 'make_available',
        CREATE_DOCUMENT = 'create_document',
        DELETE_DOCUMENT = 'delete_document',
        CREATE_INVENTORY = 'create_inventory',
        UPDATE_INVENTORY = 'update_inventory',
        DELETE_INVENTORY = 'delete_inventory',
        MOVED_TO_INVENTORY = 'moved_to_inventory',
        MOVED_FROM_INVENTORY = 'moved_from_inventory',
    }
}

